import React, { useEffect, useState } from "react";
// files
// third party
import { Table } from "antd";
import { allPendingUsersApi } from "../../api/api";
import LoadingSpiner from "../Common/LoadingSpiner";
import "./Table.css";

export default function PendingUserTable({ userData }) {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token, userData]);

  const fetchData = async () => {
    const res = await allPendingUsersApi();

    setData(res);
    setFilterData(res);
    setLoading(false);
  };

  // states
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState();
  const [keywords, setKeywords] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  // colums
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      responsive: ["sm", "md", "lg", "xl"],
      render: (name) => <h4 className="text-[15px]">{name}</h4>,
    },
    {
      title: "Patient DOB",
      dataIndex: "birthday",
      key: "dob",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
      responsive: ["sm"],
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (title) => <h4 className="text-[15px]">{title}</h4>,
    },
  ];
  // onchange function
  const onChange = (pagination, filters, sorter, extra) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  if (loading) {
    return <LoadingSpiner loading={loading} />;
  } else {
    return (
      <div>
        <div className="container my-10">
          <div className="flex items-center justify-between">
            <div>
              {selectedRowKeys.length !== 0 && (
                <div className="flex items-center">
                  <p className="text-[10px] mr-2">
                    {selectedRowKeys.length} select{" "}
                  </p>
                </div>
              )}
            </div>
            <div className="mb-[15px] flex"></div>
          </div>
          {/* <div style={{"padding":20, "float": "left"}}>
      <Button onClick={() => exportToPdf(selectedRow)}>Export as PDF</Button>
      </div> */}
          <h2 className="table-title">Pending Users</h2>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              pagination={{
                pageSize: pageSize,
                current: page,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                },
              }}
              onChange={onChange}
              rowKey={(record) => record._id}
            />
          )}
        </div>
      </div>
    );
  }
}
